import { render } from "./OnboardingTablet.vue?vue&type=template&id=4e334bed"
import script from "./OnboardingTablet.vue?vue&type=script&lang=js"
export * from "./OnboardingTablet.vue?vue&type=script&lang=js"

import exportComponent from "/home/api.muzea.ro/wp-content/themes/szmm/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__